<template>
  <div class="template-list-widget">
    <div class="widget-header">
      <widgetSearch class="widget-search" icon="right" placeholder="Search CV" @keyup="searchCVs"></widgetSearch>
      <div class="widget-title-widget">
        <h1 v-if="selected_item_type == 'profile'" class="widget-title">
          {{ selected_profile.first_name + " " + selected_profile.last_name }}
          ({{ cvsList.length }})
        </h1>
        <h1 v-else-if="selected_item_type == 'department'" class="widget-title">
          {{ selected_department.name }}
          ({{ cvsList.length }})
        </h1>
        <h1 v-else-if="selected_item_type == 'team'" class="widget-title">
          {{ selected_team.name }}
          ({{ cvsList.length }})
        </h1>
        <h1 v-else class="widget-title">All CVs ({{ cvsList.length }})</h1>

        <widgetButton v-if="cvs_active_tab == 1" :loading="false" @click="addNewCV()" class="btn btn-secondary">
          <img src="@/assets/icons/upload.svg" class="img-icon" /> Add CV
        </widgetButton>
      </div>
      <div class="cvs-tab-widget">
        <widgetTabs :tabs="[
          {
            title: 'CVs',
            value: 1,
          },
          {
            title: 'Templates',
            value: 2,
          },
        ]" v-model="cvs_active_tab" @change="(tab) => {
  if (tab.value == 1) {
    if (selected_profile) {
      getCvsForSelectedProfile(selected_profile);
    } else {
      getCvsData();
    }
  }
  if (tab.value == 2) {
    getTemplateData('mine');
  }
}
  "></widgetTabs>
      </div>
    </div>
    <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="is_loading" :is-full-page="false"
      :can-cancel="false" background-color="#fff" class="loader"></loading>
    <div class="widget-body" :class="{ noScoll: template_menu_open }">
      <div class="widget-section" ref="cvs_list" v-if="cvs_active_tab == 1 && cvsList.length > 0">
        <div class="template-item" v-for="(item, index) in cvsList" :key="index">
          <div class="template-content">
            <div class="template-content-header">
              <div class="template-name" @click="previewCv(item)">
                {{ item.name }}
              </div>
              <div class="template-date">
                {{ moment(item.created_at).format("MMMM YYYY") }}
              </div>
              <div class="template-option">
                <widgetDropdown v-model="item.menu" :right="true" :hover="false" :interactive="true">
                  <button class="btn-dropdown btn-menu">
                    <img class="icon" style="height: 20px" src="@/assets/cv-editor-icons/menu-dot-gray.svg" />
                  </button>
                  <div slot="dropdown" class="dropdown-widget" style="right: -9px">
                    <a v-if="!item.default && account_type == 'student'" class="dropdown-item" href="#"
                      @click.prevent="setAsDefault(item)">Set As Default
                    </a>
                    <a v-else class="dropdown-item" href="#" @click.prevent="downloadCv(item)">Download
                    </a>
                    <a v-if="item.origin != 'external'" class="dropdown-item" href="#" @click.prevent="editCv(item)">Edit
                    </a>
                    <a class="dropdown-item" href="#" @click.prevent="previewCv(item)">Preview
                    </a>
                    <app-dialog title="Delete Template" ask="Are you sure you want to permanently delete cv?"
                      yesText="Delete" noText="Cancel" @onComfirm="deleteCV(item)">
                      <a class="dropdown-item" href="#">Delete </a>
                    </app-dialog>
                  </div>
                </widgetDropdown>
              </div>
            </div>

            <div @click="previewCv(item)" v-if="item.user" class="template-owner-names">
              {{ item.user.first_name + " " + item.user.last_name }}
            </div>
            <div @click="previewCv(item)" class="template-discription">
              {{ item.description }}
            </div>
            <div class="template-footer">
              <div v-if="item.default" class="template-default-status">
                Default
              </div>
              <div class="template-banner uploaded" v-if="item.origin == 'external'">
                Uploaded
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="not-found" v-if="cvs_active_tab == 1 && cvsList.length == 0">
        <widgetNotFoundWidget title="No Cvs Found" content="Looks like you haven’t added any CVs yet">
          <img class="widget-img" src="@/assets/icons/member-notfound.svg" />
        </widgetNotFoundWidget>
      </div>
      <div class="template-widget-section" ref="template_list" v-if="cvs_active_tab == 2">
        <div class="template-item" v-for="(item, index) in templateList" :key="index">
          <div class="template-header">
            <widgetDropdown v-model="item.menu" :right="true" :hover="false" :interactive="true">
              <button class="btn-dropdown btn-menu">
                <img class="icon" style="height: 20px" src="@/assets/cv-editor-icons/menu-dot.svg" />
              </button>
              <div slot="dropdown" class="dropdown-widget right">
                <a class="dropdown-item" @click="previewTemplate(item)"> Preview
                </a>
                <a class="dropdown-item" @click="genelateCvFromTemplate(item)" href="#">Apply
                </a>
                <a class="dropdown-item" @click="editTemplate(item)" href="#">Edit
                </a>
                <app-dialog v-if="account_type == 'school'
                  " title="Are you sure?" ask="Are you sure you want to share this template?" yesText="Yes"
                  noText="Cancel" yesBtnClass="approve-widget" @onComfirm="shareTemplate(item)">

                  <a class="dropdown-item" href="#">Share
                  </a>
                </app-dialog>
                <app-dialog v-if="account_type == 'school'
                  " title="Are you sure?" ask="Are you sure you want to stop sharing this template?" yesText="Yes"
                  noText="Cancel" yesBtnClass="approve-widget" @onComfirm="stopShareTemplate(item)">
                  <a class="dropdown-item" href="#">Stop Share
                  </a>

                </app-dialog>
                <app-dialog title="Delete Template" ask="Are you sure you want to permanently delete template?"
                  yesText="Delete" noText="Cancel" @onComfirm="deleteTemplate(item)">
                  <a class="dropdown-item" href="#">Delete </a>
                </app-dialog>
              </div>
            </widgetDropdown>
          </div>
          <div class="template-img" @click="previewTemplate(item)">
            <img :src="$fullUrl('images/profiles/' + item.thumb)" />
            <div class="default-cv" v-if="item.default">Default CV</div>
          </div>
          <div class="template-name">{{ item.name }}</div>
        </div>
      </div>
      <div class="not-found" v-if="cvs_active_tab == 2 && templateList.length == 0">
        <widgetNotFoundWidget title="No template Found" content="Looks like you haven’t added any template yet">
          <img class="widget-img" src="@/assets/icons/member-notfound.svg" />
        </widgetNotFoundWidget>
      </div>
    </div>

    <!-- Add new cv modal -->
    <widgetModal v-if="show_add_new_cv_form" :title="form.origin == 'external'
      ? 'Upload Cv'
      : form.id
        ? 'Update Cv information'
        : 'Create CV'
      " subtitle="Fill in the information below " btnlefttext="Save Changes" btncentertext="Cancel" btnrighttext=""
      :hiderightbtn="true" :leftloading="save_template_loading" :rightloading="false" :centerloading="false"
      :footerhidden="false" footer_padding="30px 18px 30px 30px" header_padding="30px 0px 0px 31px"
      body_padding="0px 30px" width="550px" @onLeftClick="submitCv()" @onCenterClick="show_add_new_cv_form = false">
      <div class="widget-modal-body-noscoll">
        <div class="row">
          <widgetInputWrapper title="CV Name">
            <widgetInput type="text" v-model="form.name" placeholder=""></widgetInput>
          </widgetInputWrapper>
        </div>
        <div class="row" v-if="account_type == 'school'">
          <widgetInputWrapper :title="APPLICATION_NAME == 'meritios'
            ? `Select student`
            : `Select consultant`
            ">
            <widgetSearchUserInput v-model="selected_profile" @change="(user) => {
              form.user_id = user.id;
            }
              "></widgetSearchUserInput>
          </widgetInputWrapper>
        </div>

        <div class="row">
          <widgetInputWrapper title="CV Description">
            <widgetTextarea v-model="form.description" placeholder=""></widgetTextarea>
          </widgetInputWrapper>
        </div>
        <div class="row" v-if="form.origin == 'external'">
          <Uploader @onFileSelected="(file) => {
            form.file = file;
          }
            " :max_size="5" caption="Upload your document [max-size: 5MB] [pdf]" accept="application/pdf"
            remove_caption="Remove file" :value="{
              url: $fullUrl('files/crm/'),
              file_name: '',
            }" />
        </div>
      </div>
    </widgetModal>

    <!-- Send Message Button -->
    <button v-if="selected_profile && selected_cv" @click="sendMessage()" class="btn-send-message">
      Comment
    </button>
  </div>
</template>
<script>
import { SITE_API } from "@/Store/variable.js";
import { eventBus } from "@/main";
export default {
  name: "editor-menu",
  components: {},
  props: {
    account_type: {
      type: String,
      default: "school",
    },
    templateAllowedVersion: {
      type: String,
      default: "1.3"
    }
  },
  data() {
    return {
      template_menu_open: false,
      selected_cv: null,
      templateList: [],
      cvsList: [],
      show_add_new_cv_form: false,
      save_template_loading: false,
      renameForm: { id: null, name: "" },
      active_template_tab: 1,
      is_loading: false,
      form: {
        id: null,
        name: "",
        user_id: "",
        description: "",
        file: null,
        isDraft: false,
        origin: "external",
        cvData: "",
      },
      selected_profile: null,
      cvs_active_tab: 1,
      selected_department: null,
      selected_team: null,
      selected_item_type: "",
      fullProfileData: {
        hasData: false,
        profile: {
          profile_id: null,
          profile_first_name: '',
          profile_last_name: '',
          profile_image: '',
          profile_email: '',
          profile_phone: '',
          profile_address: '',
          profile_description: '',
        },
        projects: [],
        employments: [],
        educations: [],
        trainings: [],
        certifications: [],
        skills: [],
        skillsObject: null
      },
      currentyProfileDataIndexing: {
        projects: 0,
        employments: 0,
        educations: 0,
        trainings: 0,
        certifications: 0,
        skills: 0
      },
      layers: [],
      templateData: null,
      isApplyingProfile: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    let vm = this;
    vm.getTemplateData("mine");
    vm.getCvsData();
    eventBus.$on("profileSelected", (profile) => {
      if (vm.cvs_active_tab == 1) {
        vm.selected_profile = profile;
        vm.form.user_id = profile.id;
        vm.selected_item_type = "profile";
        vm.getCvsForSelectedProfile(profile);
      }
    });
    eventBus.$on("departmentSelected", (department) => {
      if (vm.cvs_active_tab == 1) {
        vm.selected_department = department;
        vm.selected_item_type = "department";
        vm.getCvsForSelectedDepartment(department);
      }
    });
    eventBus.$on("teamSelected", (team) => {
      if (vm.cvs_active_tab == 1) {
        vm.selected_team = team;
        vm.selected_item_type = "team";
        vm.getCvsForSelectedTeam(team);
      }
    });

    if (vm.account_type == "school") {
      if (!vm.$route.query.user) {
        vm.getCvsData();
      } else {
        let user_id = parseInt(vm.$route.query.user);
        vm.is_loading = true;
        vm.$store
          .dispatch("CVS_GET_STUDENT_INFORMATION", {
            student_id: user_id,
            type: vm.account_type,
          })
          .then((response) => {
            vm.selected_profile = response.data;
            vm.form.user_id = user_id;
            vm.selected_item_type = "profile";
            vm.getCvsForSelectedProfile({ id: user_id });
          })
          .catch((error) => { });
      }
    } else {
      vm.selected_profile = vm.$getLoggedUser();
      vm.selected_item_type = "profile";
    }
  },
  methods: {
    sendMessage() {
      let vm = this;
      window.parent.postMessage(
        { message: "sendMessage", value: vm.selected_profile },
        "*"
      );
    },
    shareTemplate(item) {
      let vm = this;
      vm.$store
        .dispatch("CVS_SHARE_TEMPLATE", { id: item.id, type: vm.account_type })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Messsage",
            text: "Template is now shared",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    stopShareTemplate(item) {
      let vm = this;
      vm.$store
        .dispatch("CVS_STOP_SHARE_TEMPLATE", {
          id: item.id,
          type: vm.account_type,
        })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Messsage",
            text: "Template is now removed from shared",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    setAsDefault(item) {
      let vm = this;
      vm.$store
        .dispatch("CVS_SET_AS_DEFAULT", {
          id: item.id,
          type: vm.account_type,
          user_id: item.user_id,
        })
        .then((response) => {
          vm.getCvsData();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Message",
            text: "CV was set as default",
          });
        })
        .catch((error) => { });
    },
    createTemplate() {
      let vm = this;
      vm.$emit("createTemplate", null);
    },
    downloadCv(item) {
      let vm = this;
      vm.selected_cv = item;
      if (item.origin == "internal") {
        vm.$emit("previewCv", item, true);
      } else {
        let image_link =
          SITE_API + "/super-manager/cvs/image/download?name=" + item.path;
        let ext = item.path.split(".").pop();
        let file_name = item.name + "." + ext;
        // trun image into base64
        let xhr = new XMLHttpRequest();
        xhr.open("GET", image_link, true);
        xhr.responseType = "blob";
        xhr.onload = function (e) {
          if (this.status == 200) {
            let url = window.URL.createObjectURL(this.response);
            let link = document.createElement("a");
            link.href = url;
            link.download = file_name;
            link.click();
          }
        };
        xhr.send();
      }
    },
    // ==================================================================
    profileSelected(userId) {
      let vm = this;
      vm.fullProfileData.hasData = false;
      vm.currentyProfileDataIndexing = {
        projects: 0,
        employments: 0,
        educations: 0,
        trainings: 0,
        certifications: 0,
        skills: 0
      };
      vm.$store
        .dispatch("GET_ME_PROFILE", {
          id: userId,
          type: "student",
        })
        .then((response) => {
          vm.joinPrepareProfileData(response.data, response.data.user);
        })
        .catch((error) => {
          vm.fullProfileData.hasData = false;
          vm.isLoading = false;
          console.error({ error });
        });
    },
    joinPrepareProfileData(profileData, userProfile) {
      let vm = this;
      vm.fullProfileData.profile.profile_id = userProfile.copy;
      vm.fullProfileData.profile.profile_first_name = userProfile.first_name;
      vm.fullProfileData.profile.profile_last_name = userProfile.last_name;
      vm.fullProfileData.profile.profile_email = userProfile.email;
      vm.fullProfileData.profile.profile_image = userProfile.profile_picture;
      if (userProfile.profile) {
        vm.fullProfileData.profile.profile_phone = userProfile.profile.phone;
        vm.fullProfileData.profile.profile_address = userProfile.profile.address;
        vm.fullProfileData.profile.profile_description = vm.htmlToText(userProfile.profile.description);
      }
      vm.fullProfileData.projects = profileData.projects.map(item => {
        let { skillsObject, skillsArray } = vm.processSkills(item.skills);
        return {
          project_name: item.name,
          project_company: item.company ? item.company.name : '',
          project_address: item.address,
          project_description: vm.htmlToText(item.description),
          project_start_date: item.from ? vm.moment(item.from).format('MMM DD YYYY') : '',
          project_end_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
          project_skills: skillsArray,
        }
      });
      vm.fullProfileData.employments = profileData.employment.map(item => {
        let { skillsObject, skillsArray } = vm.processSkills(item.skills);
        return {
          employment_company: item.company ? item.company.name : '',
          employment_position: item.role,
          employment_address: item.address,
          employment_description: vm.htmlToText(item.description),
          employment_start_date: item.from ? vm.moment(item.from).format('MMM DD YYYY') : '',
          employment_end_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
          employment_skills: skillsArray,
        }
      });
      vm.fullProfileData.educations = profileData.educations.map(item => {
        return {
          education_school: item.organization,
          education_degree: item.degree,
          education_address: item.address,
          education_start_date: item.from ? vm.moment(item.from).format('MMM DD YYYY') : '',
          education_end_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
        }
      });
      vm.fullProfileData.trainings = profileData.trainings.map(item => {
        return {
          training_certificate: item.title,
          training_institution: item.organization,
          training_address: item.address,
          training_start_date: item.from ? vm.moment(item.from).format('MMM DD YYYY') : '',
          training_end_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
        }
      });
      vm.fullProfileData.certifications = profileData.certifications.map(item => {
        return {
          certification_name: item.name,
          certification_institution: item.organization,
          certification_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
          certification_description: item.description
        }
      });
      let { skillsObject, skillsArray } = vm.processSkills(profileData.skills);
      vm.fullProfileData.skills = skillsArray;
      vm.fullProfileData.skillsObject = skillsObject;
      vm.isApplyingProfile = true;
      vm.fullProfileData.hasData = true;
      // Combine all data
      if (vm.fullProfileData.hasData) {
        vm.$emit("createTemplate", {
          type: 'cv',
          action: 'editAppliedCv',
          data: { layers: JSON.parse(vm.selected_cv.cvData).cvData, cv: vm.selected_cv, template: vm.templateData, profile: vm.fullProfileData },
        });
      }

    },
    processSkills(skills_data) {
      let skills = {
        tools: [],
        domains: [],
        languages: [],
        competences: [],
        roles: [],
      };
      let skillsArray = [];
      if (skills_data && skills_data.length > 0) {
        skills_data.forEach((skill) => {
          skill.tools.forEach((item) => {
            let obj = {
              id: item.id,
              name: item.name,
              priority: item.priority,
              editMode: false,
              type: "tools",
              order: item.order,
              status: item.status,
              searchable: item.status === 0 ? false : true,
              level: parseInt(item.priority),
            };
            skills.tools.push(obj);
            skillsArray.push(obj);
          });
          skill.domains.forEach((item) => {
            let obj = {
              id: item.id,
              name: item.name,
              priority: item.priority,
              editMode: false,
              type: "domains",
              order: item.order,
              status: item.status,
              searchable: item.status === 0 ? false : true,
              level: parseInt(item.priority),
            };
            skills.domains.push(obj);
            skillsArray.push(obj);
          });
          skill.competences.forEach((item) => {
            let obj = {
              id: item.id,
              name: item.name,
              priority: item.priority,
              editMode: false,
              type: "competences",
              order: item.order,
              status: item.status,
              searchable: item.status === 0 ? false : true,
              level: parseInt(item.priority),
            };
            skills.competences.push(obj);
            skillsArray.push(obj);
          });
          skill.roles.forEach((item) => {
            let obj = {
              id: item.id,
              name: item.name,
              priority: item.priority,
              editMode: false,
              type: "roles",
              order: item.order,
              status: item.status,
              searchable: item.status === 0 ? false : true,
              level: parseInt(item.priority),
            };
            skills.roles.push(obj);
            skillsArray.push(obj);
          });
          skill.languages.forEach((item) => {
            if (item.lang) {
              let obj = {
                id: item.id,
                name: item.lang.name,
                lang: item.lang.id,
                editMode: false,
                type: "languages",
                order: item.order,
                status: item.status,
                searchable: item.status === 0 ? false : true,
                level: parseInt(item.level),
              };
              skills.languages.push(obj);
              skillsArray.push(obj);
            }
          });
        });
      }
      return {
        skillsObject: skills,
        skillsArray
      };
    },
    editCv(item) {
      let vm = this;
      vm.selected_cv = item;
      let cvData = JSON.parse(vm.selected_cv.cvData);
      if (cvData.version == vm.templateAllowedVersion) {
        vm.$store
          .dispatch("CVS_GET_TEMPLATE_ITEM", {
            template_id: item.template_id || null,
          })
          .then((response) => {
            vm.templateData = JSON.parse(response.data.cvData);
            vm.profileSelected(item.user_id);
          })
          .catch((error) => {
            console.error({ error });
          });
      } else {
        vm.$notify({
          group: "status",
          title: "Message",
          text: "This CV is not supported.",
          type: "warn",
          duration: 3000,
        });
      }
    },
    // ==================================================================
    genelateCvFromTemplate(item) {
      let vm = this;
      // Open Editor as template
      vm.$emit("createTemplate", {
        type: 'template',
        action: 'apply',
        data: item,
      });
    },
    editTemplate(item) {
      let vm = this;
      // Open Editor as template
      vm.$emit("createTemplate", {
        type: 'template',
        action: 'edit',
        data: item,
      });
    },
    deleteTemplate(item) {
      let vm = this;
      vm.$store
        .dispatch("CVS_DELETE_TEMPLATE", { id: item.id, type: vm.account_type })
        .then((response) => {
          vm.getTemplateData();
          vm.$notify({
            group: "status",
            title: "Messsage",
            text: "Template deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    getTemplateData(type) {
      let vm = this;
      vm.is_loading = true;
      vm.$store
        .dispatch("CVS_GET_TEMPLATES", {
          filter: type,
          type: vm.account_type,
        })
        .then((response) => {
          vm.is_loading = false;
          vm.templateList = response.data;
        })
        .catch((error) => {
          vm.is_loading = false;
          console.error({ error });
        });
    },
    previewCv(item) {
      let vm = this;
      vm.selected_cv = item;
      if (item.origin == "internal") {
        vm.$emit("previewCv", item);
      } else {
        vm.$emit("previewPdf", {
          url: vm.$fullUrl("images/profiles/" + item.path),
        });
      }
    },
    previewTemplate(item) {
      let vm = this;
      vm.$emit("previewTemplate", item);
    },
    hideMenu() {
      let vm = this;
      vm.template_menu_open = false;
    },
    getCvsForSelectedProfile(profile) {
      let vm = this;
      vm.is_loading = true;
      vm.$store
        .dispatch("CVS_GET_CVS", {
          user_id: profile.id,
          type: vm.account_type,
          isDraft: false,
          origin: "all"
        })
        .then((response) => {
          vm.is_loading = false;
          vm.cvsList = response.data;
        })
        .catch((error) => {
          vm.is_loading = false;
          console.error({ error });
        });
    },
    getCvsForSelectedDepartment(department) {
      let vm = this;
      vm.is_loading = true;
      vm.$store
        .dispatch("CVS_GET_CVS", {
          division_id: department.id,
          type: vm.account_type,
          isDraft: false,
          origin: "all"
        })
        .then((response) => {
          vm.is_loading = false;
          vm.cvsList = response.data;
        })
        .catch((error) => {
          vm.is_loading = false;
          console.error({ error });
        });
    },
    getCvsForSelectedTeam(team) {
      let vm = this;
      vm.is_loading = true;
      vm.$store
        .dispatch("CVS_GET_CVS", {
          class_id: team.id,
          type: vm.account_type,
          isDraft: false,
          origin: "all"
        })
        .then((response) => {
          vm.is_loading = false;
          vm.cvsList = response.data;
        })
        .catch((error) => {
          vm.is_loading = false;
          console.error({ error });
        });
    },
    searchCVs({ target }) {
      let vm = this;
      let query = target.value;
      vm.is_loading = true;
      vm.$store
        .dispatch("CVS_GET_CVS", {
          text: query,
          type: vm.account_type,
          isDraft: false,
          origin: "all"
        })
        .then((response) => {
          vm.is_loading = false;
          vm.cvsList = response.data;
        })
        .catch((error) => {
          vm.is_loading = false;
          console.error({ error });
        });
    },
    addNewCV() {
      let vm = this;
      vm.form.id = null;
      vm.form.name = "";
      vm.form.user_id = "";
      vm.form.description = "";
      vm.form.file = null;
      vm.form.origin = "external";
      vm.form.cvData = "";
      vm.show_add_new_cv_form = true;
    },
    submitCv() {
      let vm = this;
      vm.save_template_loading = true;
      let formData = new FormData();
      formData.append("id", vm.form.id);
      formData.append("name", vm.form.name);
      if (vm.account_type == "school") {
        formData.append("user_id", vm.selected_profile.id);
      } else {
        let user_id = vm.$getLoggedUser().id;
        formData.append("user_id", user_id);
      }
      formData.append("description", vm.form.description);
      formData.append("type", vm.account_type);
      formData.append("origin", vm.form.origin);
      if (vm.form.origin == "external") {
        if (vm.form.file) {
          formData.append("file", vm.form.file, vm.form.file.name);
        }
      } else {
        formData.append("cvData", JSON.stringify(vm.form.cvData));
        formData.append("file", vm.form.file, "cv.png");
      }
      formData.append("isDraft", false);
      if (!vm.form.id) {
        const saveCv = () => {
          vm.$store
            .dispatch("CVS_SUBMIT_CV", formData)
            .then((response) => {
              vm.save_template_loading = false;
              vm.show_add_new_cv_form = false;
              vm.getCvsData();
              vm.$notify({
                group: "status",
                title: "Messsage",
                text: "CV has been created successfully",
                type: "success",
                duration: 3000,
              });
            })
            .catch((error) => {
              vm.save_template_loading = false;
              vm.$notify({
                group: "status",
                title: "Message",
                text: "Something went wrong",
                type: "warn",
                duration: 3000,
              });
              console.error({ error });
            });
        };
        if (vm.account_type == "school") {
          eventBus.$emit("openDialogMessage", {
            title: "Consultant approval",
            message:
              "<span style='color:#000;font-size:16px;font-weight:800'>" +
              vm.selected_profile.first_name +
              " " +
              vm.selected_profile.last_name +
              "</span>'s consent is necessary in order to upload the CV. We have informed the recipient. Following confirmation, the CV will be uploaded.",
            action_label: "Ok",
            action_path: "",
            action_close_label: "",
            callback: () => {
              saveCv();
            },
          });
        } else {
          saveCv();
        }
      } else {
        vm.$store
          .dispatch("CVS_UPDATE_CV", formData)
          .then((response) => {
            vm.save_template_loading = false;
            vm.show_add_new_cv_form = false;
            vm.getCvsData();
            vm.$notify({
              group: "status",
              title: "Messsage",
              text: "CV has been updated successfully",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.save_template_loading = false;
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Something went wrong",
              type: "warn",
              duration: 3000,
            });
            console.error({ error });
          });
      }
    },
    deleteCV(item) {
      let vm = this;
      vm.$store
        .dispatch("CVS_DELETE_CV", { id: item.id, type: vm.account_type })
        .then((response) => {
          vm.getCvsData();
          vm.$notify({
            group: "status",
            title: "Messsage",
            text: "CV deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    getCvsData() {
      let vm = this;
      vm.is_loading = true;
      if (vm.account_type == "school") {
        vm.$store
          .dispatch("CVS_GET_CVS", {
            type: vm.account_type,
            isDraft: false,
            origin: "all"
          })
          .then((response) => {
            vm.is_loading = false;
            vm.cvsList = response.data;
          })
          .catch((error) => {
            vm.is_loading = false;
            console.error({ error });
          });
      } else {
        let user_id = vm.$getLoggedUser().id;
        vm.$store
          .dispatch("CVS_GET_CVS", {
            type: vm.account_type,
            user_id: user_id,
            isDraft: false,
            origin: "all"
          })
          .then((response) => {
            vm.is_loading = false;
            vm.cvsList = response.data;
          })
          .catch((error) => {
            vm.is_loading = false;
            console.error({ error });
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.template-list-widget {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .widget-header {
    margin-bottom: 5px;
    height: 115px;

    .widget-search {
      margin-bottom: 10px;
    }

    .widget-title-widget {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .widget-title {
        font-size: 14px;
        margin: 0px;
      }

      .btn {
        width: max-content;

        .img-icon {
          margin-right: 10px;
        }
      }
    }
  }

  .widget-body {
    height: calc(100% - 80px);
    overflow-y: auto;
    position: relative;

    &.noScoll {
      overflow-y: hidden !important;
    }

    .widget-section {
      display: grid;
      grid-template-columns: 100%;
      grid-gap: 5px;
      width: 100%;
      padding-bottom: 50px;

      .template-item {
        box-sizing: border-box;
        background: #f6f6f6;
        border-radius: 5px;
        padding: 6px;
        display: flex;
        position: relative;
        cursor: pointer;

        .template-content {
          width: 100%;

          .template-content-header {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .template-name {
              color: #0884af;
              font-size: 12px;
              text-transform: capitalize;
              width: 100%;
              overflow: hidden;
              text-decoration: none;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-right: 10px;
            }

            .template-date {
              color: #8c8c8c;
              font-size: 11px;
              white-space: nowrap;
            }
          }

          .template-owner-names {
            color: #000000;
            font-size: 11px;
            margin-bottom: 1px;
          }

          .template-discription {
            color: #707070;
            font-size: 11px;
            -webkit-line-clamp: 4;
            display: box;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            white-space: normal;
            overflow: hidden;
            margin-bottom: 25px;
          }

          .template-footer {
            position: absolute;
            bottom: 0;
            right: 0;
            display: flex;
            align-items: center;

            .template-banner {
              background: #0884af;
              border-radius: 0px 0px 10px 0px;
              z-index: 99;
              padding: 8px 18px;
              color: #fff;
              margin-left: 10px;
            }
          }
        }
      }
    }

    .template-widget-section {
      display: grid;
      grid-template-columns: 48% 48%;
      grid-gap: 10px;
      width: 100%;

      .template-item {
        box-sizing: border-box;
        border-radius: 10px;
        height: 200px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        position: relative;
        cursor: pointer;

        &.applied {
          border: 2px solid #1ba5a4;
        }

        .template-header {
          position: absolute;
          top: 0px;
          left: 0px;
          right: 0px;
          display: flex;
          justify-content: flex-end;
          align-items: flex-start;
          padding-top: 10px;
          padding-right: 6px;
          background: black;
          background: linear-gradient(180deg,
              rgba(0, 0, 0, 0.5) 9%,
              rgba(255, 255, 255, 0) 97%);
          z-index: 22;
          height: 50px;
          transition: all 0.5s ease;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }

        &:hover {
          .template-header {
            transition: all 0.5s ease;
            top: 0px;
          }
        }

        .template-img {
          height: calc(100% - 40px);
          display: flex;
          flex-direction: column;
          position: relative;
          border-radius: 10px;
          overflow: hidden;
          border: 1px solid #d6e0ea;

          img {
            width: 100%;
            object-fit: cover;
            height: 100%;
          }

          .default-cv {
            position: absolute;
            bottom: 0px;
            background: #1ba5a4;
            left: 0px;
            right: 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 29px;
            color: #fff;
          }
        }

        .template-name {
          padding-top: 10px;
          height: 30px;
          font-size: 12px;
          overflow: hidden;
          display: block;
          -webkit-line-clamp: 2;
          display: box;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          white-space: normal;
        }
      }
    }
  }

  .widget-modal-body-noscoll {
    .btn-upload {
      display: flex;
      align-items: center;
      margin: 10px 0px;
      color: #0884af;

      .upload-icon {
        margin-right: 10px;
      }
    }
  }

  .btn-send-message {
    position: fixed;
    z-index: 999;
    bottom: 97px;
    right: 21px;
    background: #1ba5a4;
    border: 1px solid #087a79;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
    border-radius: 5px;
    height: 40px;
    padding: 0px 17px;
    color: #fff;
  }
}
</style>